import React, { useState } from 'react';
import DailyPlan from './DailyPlan';
import MacroChart from './MacroChart';
import speechService from '../services/speechService';
import './PlanDisplay.css';

function PlanDisplay({ mealPlan, workoutPlan, foods }) {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [showChart, setShowChart] = useState(true);

  // Calculate average daily macros
  const avgMacros = mealPlan.days.reduce((acc, day) => {
    return {
      calories: acc.calories + day.breakfast.calories + day.lunch.calories + day.dinner.calories + (day.snack?.calories || 0),
      protein: acc.protein + day.breakfast.protein + day.lunch.protein + day.dinner.protein + (day.snack?.protein || 0),
      carbs: acc.carbs + day.breakfast.carbs + day.lunch.carbs + day.dinner.carbs + (day.snack?.carbs || 0),
      fat: acc.fat + day.breakfast.fat + day.lunch.fat + day.dinner.fat + (day.snack?.fat || 0)
    };
  }, { calories: 0, protein: 0, carbs: 0, fat: 0 });

  // Average per day
  const dailyMacros = {
    calories: Math.round(avgMacros.calories / 7),
    protein: Math.round((avgMacros.protein / 7) * 10) / 10,
    carbs: Math.round((avgMacros.carbs / 7) * 10) / 10,
    fat: Math.round((avgMacros.fat / 7) * 10) / 10
  };

  const handleSpeakPlan = async () => {
    if (isSpeaking) {
      speechService.stopSpeaking();
      setIsSpeaking(false);
      return;
    }

    setIsSpeaking(true);

    // Build summary text
    const summary = `Your ${mealPlan.goal} plan includes ${mealPlan.caloriesPerDay} calories per day. Average daily macros are ${dailyMacros.protein} grams of protein, ${dailyMacros.carbs} grams of carbs, and ${dailyMacros.fat} grams of fat. The plan uses foods like ${foods.slice(0, 3).map(f => f.name).join(', ')}.`;

    try {
      await speechService.speak(summary);
    } catch (error) {
      console.error('Error speaking:', error);
    } finally {
      setIsSpeaking(false);
    }
  };

  return (
    <div className="plan-display">
      <div className="plan-header">
        <div>
          <h1>✅ Your 7-Day Plan</h1>
          <p className="plan-subtitle">
            {mealPlan.goal === 'cut' ? 'Fat Loss Plan' : mealPlan.goal === 'bulk' ? 'Muscle Building Plan' : 'Balanced Fitness Plan'}
          </p>
          <div className="plan-stats">
            <span>🔥 {dailyMacros.calories} kcal/day</span>
            <span>💪 {dailyMacros.protein.toFixed(0)}g protein/day</span>
          </div>
        </div>
        <div className="plan-actions">
          <button
            onClick={() => setShowChart(!showChart)}
            className="action-button"
          >
            {showChart ? '📊 Hide Chart' : '📊 Show Chart'}
          </button>
          <button
            onClick={handleSpeakPlan}
            className={`action-button ${isSpeaking ? 'speaking' : ''}`}
          >
            {isSpeaking ? '🔊 Stop Speaking' : '🔊 Read Aloud'}
          </button>
        </div>
      </div>

      {showChart && <MacroChart macros={dailyMacros} />}

      <div className="days-container">
        {mealPlan.days.map((dayData, index) => (
          <DailyPlan
            key={dayData.day}
            day={dayData.day}
            breakfast={dayData.breakfast}
            lunch={dayData.lunch}
            dinner={dayData.dinner}
            snack={dayData.snack}
            workout={workoutPlan?.workouts[index]}
          />
        ))}
      </div>
    </div>
  );
}

export default PlanDisplay;

